import React, { useEffect, useState } from 'react';
import { dismissScoringToast, scoringToasts, subscribeScoringToasts, type ScoringToast } from './admin-toasts';

/** Fixed confirmations for admin changes, above the page and the mobile keyboard. */
export function AdminToasts() {
  const [toasts, setToasts] = useState<ScoringToast[]>(() => scoringToasts());

  useEffect(() => subscribeScoringToasts(() => setToasts(scoringToasts())), []);

  if (toasts.length === 0) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-3 z-[80] flex flex-col items-center gap-2 px-4">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          data-scoring-toast=""
          role="status"
          className="pointer-events-auto flex max-w-md items-center gap-3 rounded-[var(--radius-md)] border border-[var(--color-success)] bg-[var(--color-success-subtle)] px-4 py-3 text-sm font-medium text-[var(--color-success-text)] shadow-[var(--shadow-lg)]"
        >
          <button type="button" onClick={() => dismissScoringToast(toast.id)} className="min-w-0 flex-1 text-left">
            {toast.message}
          </button>
          {toast.action ? (
            <button
              type="button"
              onClick={() => {
                toast.action?.run();
                dismissScoringToast(toast.id);
              }}
              className="inline-flex min-h-11 shrink-0 items-center rounded-[var(--radius-md)] bg-[var(--color-success-text)] px-3 text-sm font-semibold text-white"
            >
              {toast.action.label}
            </button>
          ) : null}
        </div>
      ))}
    </div>
  );
}
